import React from 'react';
import PropTypes from 'prop-types';
import Toast from "./Toast";
import {ReactComponent as RedWarning} from "assets/img/wms/danger.svg"
import {FormattedMessage} from "react-intl";

DropNotAllowedToast.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    shippingMethodName: PropTypes.string.isRequired,
    isDesktop: PropTypes.bool,
    isTop: PropTypes.bool
};

function DropNotAllowedToast({open, handleClose, shippingMethodName, isDesktop = false, isTop = false}) {

    return (
        <Toast
            open={open}
            handleClose={handleClose}
            isTop={isTop}
            isDesktop={isDesktop}
            icon={<RedWarning />}
            title={<FormattedMessage id={"wms.toast.dropNotAllowed.title"} />}
            subtitle={<FormattedMessage id={"wms.toast.dropNotAllowed.subtitle"} values={{shippingMethodName: shippingMethodName}} />}
        />
    );
}

export default DropNotAllowedToast;